export default "__VITE_ASSET__BKYNJD3H__"